import { ReferralProgram } from 'modules/strapi/types';

export interface GetReferralProgramParams {
  referralCode: string | undefined;
  referralPrograms: ReferralProgram[] | undefined;
}

export const getReferralProgram = ({
  referralCode,
  referralPrograms,
}: GetReferralProgramParams) => {
  const referralProgram = referralPrograms?.find(
    program => program.referralCode === referralCode,
  );

  return referralProgram;
};
